module.exports = __webpack_public_path__ + "@/assets/img/koku-sari.115c62a1.jpeg";